export default __webpack_public_path__ + "static/media/icon-29.337cac6b.png";